import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [navIcon, setNaveIcon] = useState(true);
    const handleNavIcon = () =>{
        if(navIcon === true){
            setNaveIcon(false);
        }
        if(navIcon === false){
            setNaveIcon(true);
        }
    }

 

    return (
        <div className = 'nav-container'>
            <nav className="navbar navbar-expand-lg">
            <Link className="navbar-brand text-white" to = '/'>Navbar</Link>
            <button onClick = {handleNavIcon} className="navbar-toggler btn btn-warning" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                {
                    navIcon ? <span className = 'text-success'><i class="fa fa-list"></i></span> : <span className = 'text-danger'><i class="fa fa-times"></i></span>
                }
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                    <li  className="nav-item">
                        <NavLink className="nav-link" activeClassName="selected" exact to = '/'>Home</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" activeClassName="selected" exact to = '/about'>About Me</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" activeClassName="selected" exact to = '/Projects'>Project</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link" activeClassName="selected" exact to = '/contact'>Contact</NavLink>
                    </li>
                </ul>
                <form className="form-inline my-2 my-lg-0">
                <input className="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"/>
                <button className="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
                </form>
            </div>
            </nav>
        </div>
    );
};

export default Navbar;